/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import type { Provider } from '@ethersproject/providers'
import type { IReinvestContract, IReinvestContractInterface } from '../IReinvestContract'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_nmx',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_factory',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'factory',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nmx',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'deadline',
        type: 'uint256',
      },
      {
        internalType: 'uint128',
        name: 'signedClaimNmxAmount',
        type: 'uint128',
      },
      {
        internalType: 'uint8',
        name: 'claimV',
        type: 'uint8',
      },
      {
        internalType: 'bytes32',
        name: 'claimR',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'claimS',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'stakingService',
        type: 'address',
      },
    ],
    name: 'launchpoolReinvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: 'maxClaimNmxAmount',
        type: 'uint128',
      },
      {
        internalType: 'uint256',
        name: 'deadline',
        type: 'uint256',
      },
      {
        internalType: 'uint8',
        name: 'claimV',
        type: 'uint8',
      },
      {
        internalType: 'bytes32',
        name: 'claimR',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'claimS',
        type: 'bytes32',
      },
      {
        internalType: 'uint128',
        name: 'maxPairedTokenAmount',
        type: 'uint128',
      },
      {
        internalType: 'address',
        name: 'stakingService',
        type: 'address',
      },
    ],
    name: 'reinvestETH',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: 'maxClaimNmxAmount',
        type: 'uint128',
      },
      {
        internalType: 'uint256',
        name: 'deadline',
        type: 'uint256',
      },
      {
        internalType: 'uint8',
        name: 'claimV',
        type: 'uint8',
      },
      {
        internalType: 'bytes32',
        name: 'claimR',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'claimS',
        type: 'bytes32',
      },
      {
        internalType: 'uint128',
        name: 'maxPairedTokenAmount',
        type: 'uint128',
      },
      {
        internalType: 'address',
        name: 'stakingService',
        type: 'address',
      },
    ],
    name: 'reinvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export class IReinvestContract__factory {
  static readonly abi = _abi
  static createInterface(): IReinvestContractInterface {
    return new utils.Interface(_abi) as IReinvestContractInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IReinvestContract {
    return new Contract(address, _abi, signerOrProvider) as IReinvestContract
  }
}
